import { Link } from "react-router-dom";
import { X, Bookmark } from "lucide-react";
import { useCourse } from "../context/CourseContext";
import { useUser } from "../context/UserContext";

export default function BookmarksPanel({ open, onClose }) {
  const { course } = useCourse();
  const { user } = useUser();

  if (!open) return null;

  const items = [];
  if (course && user) {
    for (const m of course.modules) {
      for (const t of m.topics) {
        if (user.bookmarks.includes(t.id)) {
          items.push({ moduleId: m.id, topicId: t.id, title: t.title, moduleTitle: m.title });
        }
      }
    }
  }

  return (
    <div
      data-testid="bookmarks-overlay"
      className="fixed inset-0 z-[100] bg-background/70 backdrop-blur-md flex items-start justify-end"
      onClick={onClose}
    >
      <aside
        className="h-full w-full sm:max-w-md bg-card border-l border-border shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-border">
          <div className="flex items-center gap-2">
            <Bookmark className="h-4 w-4 text-brand-amber" />
            <h3 className="font-display text-xl">Your bookmarks</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-muted"
            data-testid="close-bookmarks-btn"
            aria-label="Close bookmarks"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-8 text-sm text-muted-foreground">
              No bookmarks yet. Tap the bookmark icon next to any topic to pin it here.
            </div>
          ) : (
            items.map((it) => (
              <Link
                key={it.topicId}
                to={`/module/${it.moduleId}#${it.topicId}`}
                onClick={onClose}
                data-testid={`bookmark-item-${it.topicId}`}
                className="block px-5 py-4 border-b border-border hover:bg-muted/60 transition-colors"
              >
                <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                  {it.moduleTitle}
                </div>
                <div className="text-sm font-medium mt-0.5">{it.title}</div>
              </Link>
            ))
          )}
        </div>
      </aside>
    </div>
  );
}
